import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import Pagination from "../../extra/Pagination";
import defaultImage from "../../../assets/images/default.jpg";
import {
  getWallets,
  getWalletStats,
  setWalletStatus,
  adminAdjustWallet,
} from "../../store/rewardWallet/rewardWallet.action";

const coinsToUsd = (coins) => (Number(coins || 0) / 1000).toFixed(2);

const statusBadge = (status) => {
  switch (status) {
    case "active":
      return { label: "Active", color: "#10B981", bg: "#D1FAE5" };
    case "frozen":
      return { label: "Frozen", color: "#EF4444", bg: "#FEE2E2" };
    case "review":
      return { label: "Review", color: "#F59E0B", bg: "#FEF3C7" };
    default:
      return { label: status || "—", color: "#6B7280", bg: "#F3F4F6" };
  }
};

const RewardWallets = () => {
  const dispatch = useDispatch();
  const admin = useSelector((s) => s.admin?.admin) || {};
  const { wallets, walletPagination, stats } = useSelector((s) => s.rewardWallet);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [status, setStatus] = useState("all");
  const [search, setSearch] = useState("");

  const [adjustOpen, setAdjustOpen] = useState(false);
  const [adjustWallet, setAdjustWallet] = useState(null);
  const [adjustAmount, setAdjustAmount] = useState("");
  const [adjustNote, setAdjustNote] = useState("");

  const [statusOpen, setStatusOpen] = useState(false);
  const [statusWallet, setStatusWallet] = useState(null);
  const [statusChoice, setStatusChoice] = useState("frozen");
  const [statusNote, setStatusNote] = useState("");

  useEffect(() => {
    dispatch(getWallets(page, limit, status, search));
  }, [dispatch, page, limit, status]);

  useEffect(() => {
    dispatch(getWalletStats());
  }, [dispatch]);

  const handleSearch = () => {
    setPage(1);
    dispatch(getWallets(1, limit, status, search));
  };

  const openAdjust = (wallet) => {
    setAdjustWallet(wallet);
    setAdjustAmount("");
    setAdjustNote("");
    setAdjustOpen(true);
  };

  const submitAdjust = () => {
    const amount = parseInt(adjustAmount, 10);
    if (!Number.isInteger(amount) || amount === 0) {
      alert("Amount must be a non-zero integer (positive to credit, negative to debit).");
      return;
    }
    if (!adjustNote.trim()) {
      alert("A note is required.");
      return;
    }
    dispatch(
      adminAdjustWallet(
        String(adjustWallet.userId),
        amount,
        adjustNote.trim(),
        admin?._id || "admin",
        (ok) => {
          if (ok) {
            setAdjustOpen(false);
            dispatch(getWalletStats());
          }
        }
      )
    );
  };

  const openStatus = (wallet) => {
    setStatusWallet(wallet);
    setStatusChoice(wallet.status === "active" ? "frozen" : "active");
    setStatusNote("");
    setStatusOpen(true);
  };

  const submitStatus = () => {
    if (!statusNote.trim()) {
      alert("A note is required.");
      return;
    }
    dispatch(
      setWalletStatus(
        String(statusWallet.userId),
        statusChoice,
        admin?._id || "admin",
        statusNote.trim(),
        (ok) => {
          if (ok) {
            setStatusOpen(false);
            dispatch(getWalletStats());
          }
        }
      )
    );
  };

  return (
    <div className="mainSellerTable">
      <div className="sellerTable">
        <div className="col-12 headname">Reward Wallets</div>

        {/* Stats */}
        <div className="row mx-2 mb-3">
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #EBF5FF)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Total Wallets</p>
              <h3 className="mb-0" style={{ color: "#1F2937", fontWeight: "600" }}>{stats?.totalWallets || 0}</h3>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #D1FAE5)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Coins in Circulation</p>
              <h3 className="mb-0" style={{ color: "#1F2937", fontWeight: "600" }}>
                {stats?.totalBalance || 0}
                <span style={{ fontSize: 14, color: "#6B7280", marginLeft: 8 }}>
                  (${coinsToUsd(stats?.totalBalance)})
                </span>
              </h3>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #F3E8FF)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Lifetime Earned</p>
              <h3 className="mb-0" style={{ color: "#1F2937", fontWeight: "600" }}>{stats?.totalLifetimeEarned || 0}</h3>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 col-12 mb-2">
            <div className="p-3" style={{ background: "linear-gradient(145deg, #ffffff, #FEF3C7)", borderRadius: "8px" }}>
              <p className="mb-1" style={{ color: "#6B7280", fontSize: "14px" }}>Frozen / Review</p>
              <h3 className="mb-0" style={{ color: "#1F2937", fontWeight: "600" }}>
                {(stats?.frozenWallets || 0) + (stats?.reviewWallets || 0)}
                <span style={{ fontSize: 14, color: "#6B7280", marginLeft: 8 }}>
                  of {stats?.totalWallets || 0}
                </span>
              </h3>
            </div>
          </div>
        </div>

        <div className="sellerMain">
          <div className="tableMain">
            <div className="sellerHeader primeHeader">
              <div className="row align-items-center">
                <div className="col-xl-2 col-md-3 col-6 mb-2">
                  <select
                    className="form-select"
                    value={status}
                    onChange={(e) => { setStatus(e.target.value); setPage(1); }}
                    style={{ borderRadius: "5px", padding: "8px" }}
                  >
                    <option value="all">All Statuses</option>
                    <option value="active">Active</option>
                    <option value="frozen">Frozen</option>
                    <option value="review">Review</option>
                  </select>
                </div>

                <div className="col-xl-7 col-md-6 col-12 mb-2">
                  <div className="d-flex">
                    <input
                      type="text"
                      className="form-control me-2"
                      placeholder="Search by name, email, phone, uniqueId, referral code..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                      style={{ padding: "8px" }}
                    />
                    <button
                      className="btn"
                      onClick={handleSearch}
                      style={{ background: "#B93160", color: "#fff", padding: "8px 20px" }}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="primeMain">
              <table width="100%" className="primeTable text-center" style={{ maxHeight: "600px" }}>
                <thead className="sticky-top" style={{ top: "-1px", zIndex: "1" }}>
                  <tr>
                    <th className="fw-bold py-3">No</th>
                    <th className="fw-bold py-3">User</th>
                    <th className="fw-bold py-3">Balance</th>
                    <th className="fw-bold py-3">Lifetime Earn / Spend / Expire</th>
                    <th className="fw-bold py-3">Status</th>
                    <th className="fw-bold py-3">Last Earn</th>
                    <th className="fw-bold py-3">Last Spend</th>
                    <th className="fw-bold py-3">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {wallets?.length > 0 ? (
                    wallets.map((w, idx) => {
                      const sb = statusBadge(w.status);
                      const u = w.user;
                      const name = u?.fullName || [u?.firstName, u?.lastName].filter(Boolean).join(" ") || "—";
                      return (
                        <tr key={w._id}>
                          <td className="text-white py-3">{(page - 1) * limit + idx + 1}</td>
                          <td className="text-white py-3">
                            <div className="d-flex align-items-center justify-content-center">
                              <img
                                src={u?.image || defaultImage}
                                width={36}
                                height={36}
                                style={{ borderRadius: "50%", marginRight: "10px", objectFit: "cover" }}
                                alt=""
                                onError={(e) => { e.target.onerror = null; e.target.src = defaultImage; }}
                              />
                              <div className="text-start">
                                <div className="fw-medium">{name}</div>
                                <small style={{ color: "#9CA3AF" }}>
                                  {u?.email || u?.mobileNumber || u?.uniqueId || String(w.userId).slice(-8)}
                                </small>
                              </div>
                            </div>
                          </td>
                          <td className="text-white py-3">
                            <div className="fw-bold">{w.balance} coins</div>
                            <small style={{ color: "#9CA3AF" }}>${coinsToUsd(w.balance)}</small>
                          </td>
                          <td className="text-white py-3">
                            <small>
                              <span style={{ color: "#10B981" }}>+{w.lifetimeEarned || 0}</span>
                              {" / "}
                              <span style={{ color: "#EF4444" }}>-{w.lifetimeSpent || 0}</span>
                              {" / "}
                              <span style={{ color: "#F59E0B" }}>↯{w.lifetimeExpired || 0}</span>
                            </small>
                          </td>
                          <td className="py-3">
                            <span
                              className="px-3 py-1"
                              style={{
                                backgroundColor: sb.bg,
                                color: sb.color,
                                borderRadius: "20px",
                                fontSize: "12px",
                                fontWeight: 500,
                              }}
                            >
                              {sb.label}
                            </span>
                          </td>
                          <td className="text-white py-3">
                            {w.lastEarnAt ? (
                              <small>{dayjs(w.lastEarnAt).format("DD MMM 'YY HH:mm")}</small>
                            ) : (
                              <small style={{ color: "#9CA3AF" }}>—</small>
                            )}
                          </td>
                          <td className="text-white py-3">
                            {w.lastSpendAt ? (
                              <small>{dayjs(w.lastSpendAt).format("DD MMM 'YY HH:mm")}</small>
                            ) : (
                              <small style={{ color: "#9CA3AF" }}>—</small>
                            )}
                          </td>
                          <td className="py-3">
                            <button
                              className="btn btn-sm me-2"
                              onClick={() => openAdjust(w)}
                              style={{ background: "#3B82F6", color: "#fff" }}
                            >
                              Adjust
                            </button>
                            <button
                              className="btn btn-sm"
                              onClick={() => openStatus(w)}
                              style={{
                                background: w.status === "active" ? "#F59E0B" : "#10B981",
                                color: "#fff",
                              }}
                            >
                              {w.status === "active" ? "Freeze" : "Unfreeze"}
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center text-white py-5">
                        No wallets found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <Pagination
              component="div"
              count={walletPagination?.total || 0}
              totalData={walletPagination?.total || 0}
              type={"server"}
              onPageChange={(e, newPage) => setPage(newPage)}
              serverPerPage={limit}
              serverPage={page}
              setCurrentPage={setPage}
              onRowsPerPageChange={(v) => { setLimit(parseInt(v, 10)); setPage(1); }}
            />
          </div>
        </div>
      </div>

      {/* Adjust Modal */}
      {adjustOpen && (
        <div
          onClick={() => setAdjustOpen(false)}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
            zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#fff", borderRadius: 8, padding: 24, width: "90%", maxWidth: 500 }}
          >
            <h4>Adjust Wallet</h4>
            <p style={{ color: "#6B7280" }}>
              User: <strong>{adjustWallet?.user?.fullName || [adjustWallet?.user?.firstName, adjustWallet?.user?.lastName].filter(Boolean).join(" ") || String(adjustWallet?.userId)}</strong>
              <br />
              Current balance: <strong>{adjustWallet?.balance} coins</strong> (${coinsToUsd(adjustWallet?.balance)})
            </p>
            <div className="mb-3">
              <label className="form-label">Amount (positive = credit, negative = debit)</label>
              <input
                type="number"
                className="form-control"
                value={adjustAmount}
                onChange={(e) => setAdjustAmount(e.target.value)}
                placeholder="e.g. 100 or -50"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Reason / note (required)</label>
              <textarea
                className="form-control"
                rows={2}
                value={adjustNote}
                onChange={(e) => setAdjustNote(e.target.value)}
                placeholder="e.g. support-ticket #1234 — compensation for failed delivery"
              />
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn btn-secondary me-2" onClick={() => setAdjustOpen(false)}>Cancel</button>
              <button
                className="btn"
                onClick={submitAdjust}
                style={{ background: "#B93160", color: "#fff" }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Status Modal */}
      {statusOpen && (
        <div
          onClick={() => setStatusOpen(false)}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
            zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#fff", borderRadius: 8, padding: 24, width: "90%", maxWidth: 500 }}
          >
            <h4>Change Wallet Status</h4>
            <p style={{ color: "#6B7280" }}>
              User: <strong>{statusWallet?.user?.fullName || [statusWallet?.user?.firstName, statusWallet?.user?.lastName].filter(Boolean).join(" ") || String(statusWallet?.userId)}</strong>
              <br />
              Current status: <strong>{statusWallet?.status}</strong>
            </p>
            <div className="mb-3">
              <label className="form-label">New status</label>
              <select
                className="form-select"
                value={statusChoice}
                onChange={(e) => setStatusChoice(e.target.value)}
              >
                <option value="active">Active</option>
                <option value="frozen">Frozen (blocks all earn/spend)</option>
                <option value="review">Review (flag for investigation)</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Reason / note (required)</label>
              <textarea
                className="form-control"
                rows={2}
                value={statusNote}
                onChange={(e) => setStatusNote(e.target.value)}
                placeholder="e.g. velocity alert 2026-04-18 — suspected farming"
              />
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn btn-secondary me-2" onClick={() => setStatusOpen(false)}>Cancel</button>
              <button
                className="btn"
                onClick={submitStatus}
                style={{ background: "#B93160", color: "#fff" }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default connect(null, { getWallets, getWalletStats, setWalletStatus, adminAdjustWallet })(RewardWallets);
